export const SELECT_CLIENT_TITLE = 'SELECT CLIENT';
export const SELECT_CLIENT_SEARCH_PLACEHOLDER = 'SEARCH';
export const SELECT_CLIENT_CONTINUE_LABEL = 'CONTINUE';
